import React from 'react';
import '../../styles/contact.css';

// Import images (you need to add these to your project)
import contactHeroBg from '../../images/contact-hero-bg.jpg';
import officeImage from '../../images/office-image.jpg';
import teamMeeting from '../../images/team-meeting.jpg';
import cloudServices from '../../images/cloud-solutions.jpg';
import development from '../../images/appdevelopment.jpeg';
import staffing from '../../images/staffing.jpg';
import cybersecurity from '../../images/cybersecurity.jpg';
import servicepage3 from '../../images/servicepage3.jpg';

const Contact = () => {
  return (
    <main id="main">
      {/* Hero Section */}
      <section 
        className="contact-hero"
        style={{
          background: `linear-gradient(rgba(0, 46, 72, 0.85), rgba(0, 0, 0, 0.85)), url(${contactHeroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="about-hero-content">
          <div className="contact-hero-content">
            <h1 style={{ color: '#00e7ff' }}>Connect With VinfoCloud</h1>
            <p className="hero-subtitle">
              Your Partner in Digital Transformation and IT Excellence. Let's build the future together.
            </p>
            <div className="hero-stats">
              <div className="stat">
                <h3>24/7</h3>
                <p>Support Available</p>
              </div>
              <div className="stat">
                <h3>50+</h3>
                <p>Happy Clients</p>
              </div>
              <div className="stat">
                <h3>40+</h3>
                <p>Expert Team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section id="contact-info" className="contact-info-section">
        <div className="container">
          <div className="section-header">
            <h1 style={{ color: '#00e7ff' }}>How to Reach Us</h1>
            <p className="section-subtitle">
              Multiple channels to connect with our team. We're always ready to help you transform your business.
            </p>
          </div>

          <div className="contact-info-grid">
            <div className="contact-info-card">
              <div className="contact-icon">
                <i className="fa fa-map-marker-alt"></i>
              </div>
              <h3>Our Office</h3>
              <div className="contact-image">
                <img src={officeImage} alt="VinfoCloud Office" />
              </div>
              <address>
                <strong>VinfoCloud Technologies Inc.</strong><br />
                6250 Westpark Dr, Suite 319<br />
                Houston, TX 77057<br />
                United States
              </address>
              <a href="#map-section" className="view-map">View on Map →</a>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <i className="fa fa-envelope-open-text"></i>
              </div>
              <h3>Direct Email Contacts</h3>
              <div className="email-contacts">
                <div className="email-category">
                  <h4>General Inquiries</h4>
                  <a className="email-link">
                    Sales Inquiries
                  </a>
                </div>
                <div className="email-category">
                  <h4>Business Development</h4>
                  <a className="email-link">
                    Technical Support
                  </a>
                </div>
                <div className="email-category">
                  <h4>Career Opportunities</h4>
                  <a className="email-link">
                    Business Partnerships
                  </a>
                </div>
                <div className="email-category">
                  <h4>Technical Support</h4>
                  <a href="mailto:contactus@vinfocloud.com" className="email-link">
                    contactus@vinfocloud.com
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <i className="fa fa-headset"></i>
              </div>
              <h3>Support & Operations</h3>
              <div className="support-image">
                <img src={teamMeeting} alt="Team Support Meeting" />
              </div>
              <div className="support-hours">
                <div className="hours-block">
                  <h4>Business Hours</h4>
                  <p><strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM CST</p>
                  <p><strong>Weekend Support:</strong> Available for emergencies</p>
                </div>
                <div className="hours-block">
                  <h4>24/7 Support</h4>
                  <p>For managed service clients and critical issues</p>
                  {/* <a href="tel:+12814000000" className="emergency-contact">
                    <i className="fa fa-phone"></i> +1 (281) 400-0000
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service-Specific Contacts */}
      <section className="service-contacts-section">
        <div className="container">
          <div className="section-header">
            <h1 style={{ color: '#00e7ff' }}> Specialized Team Contacts</h1>
            <p className="section-subtitle">
              Connect directly with our expert teams for specific service inquiries
            </p>
          </div>

          <div className="service-contacts-grid">
            <div className="service-contact-card">
              <div className="service-image">
                <img src={cloudServices} alt="Cloud Services" />
              </div>
              <div className="service-content">
                <div className="service-icon">
                  <i className="fa fa-cloud"></i>
                </div>
                <h3>Cloud & Infrastructure</h3>
                <p>AWS consulting, cloud migration, DevOps, infrastructure management</p>
                <div className="service-contacts">
                  <a href="mailto:contact@vinfocloud.com" className="service-email">
                    Scalable. Secure. Always Available.
                  </a>
                  <span className="service-tag">Response: 1-2 hours</span>
                </div>
              </div>
            </div>

            <div className="service-contact-card">
              <div className="service-image">
                <img src={development} alt="Software Development" />
              </div>
              <div className="service-content">
                <div className="service-icon">
                  <i className="fa fa-code"></i>
                </div>
                <h3>Software Development</h3>
                <p>Custom applications, web/mobile development, enterprise solutions</p>
                <div className="service-contacts">
                  <a href="mailto:contact@vinfocloud.com" className="service-email">
                    Custom Software Aligned to Your Business
                  </a>
                  <span className="service-tag">Response: 2-4 hours</span>
                </div>
              </div>
            </div>

            <div className="service-contact-card">
              <div className="service-image">
                <img src={staffing} alt="IT Staffing" />
              </div>
              <div className="service-content">
                <div className="service-icon">
                  <i className="fa fa-user-tie"></i>
                </div>
                <h3>IT Staffing Solutions</h3>
                <p>Technical recruitment, contract staffing, talent acquisition</p>
                <div className="service-contacts">
                  <a href="mailto:contact@vinfocloud.com" className="service-email">
                    Connecting You With the Right Tech Talent
                  </a>
                  <span className="service-tag">Response: 24 hours</span>
                </div>
              </div>
            </div>

            <div className="service-contact-card">
              <div className="service-image">
                <img src={cybersecurity} alt="Cybersecurity" />
              </div>
              <div className="service-content">
                <div className="service-icon">
                  <i className="fa fa-shield-alt"></i>
                </div>
                <h3>Cybersecurity</h3>
                <p>Security audits, compliance, threat protection, risk assessment</p>
                <div className="service-contacts">
                  <a href="mailto:contact@vinfocloud.com" className="service-email">
                    Smart Security for a Digital World
                  </a>
                  <span className="service-tag">Response: 4-6 hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Location & Map Section */}
      <section id="map-section" className="location-section">
        <div className="container">
          <div className="location-header">
            <h2 style={{ color: '#00e7ff' }}>Visit Our Houston Office</h2>
            <p className="location-subtitle">
              Our central location in Houston makes us easily accessible for meetings and collaborations
            </p>
          </div>
          
          <div className="location-content">
            <div className="map-container">
              <div className="map-wrapper">
                <iframe
                  title="VinfoCloud Houston Office Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3464.7716000000003!2d-95.506544!3d29.732156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c2f4d5f8b0b1%3A0x8a3b8b3b3b3b3b3b!2s6250%20Westpark%20Dr%2C%20Houston%2C%20TX%2077057!5e0!3m2!1sen!2sus!4v1634567890123!5m2!1sen!2sus"
                  width="100%"
                  height="500"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
            
            <div className="facility-details">
              <div className="facility-info">
                <h3><i className="fa fa-building"></i> Facility Features</h3>
                <ul>
                  <li><i className="fa fa-check-circle"></i> Modern conference rooms with video conferencing</li>
                  <li><i className="fa fa-check-circle"></i> High-speed internet and secure Wi-Fi</li>
                  <li><i className="fa fa-check-circle"></i> Client lounge and collaboration spaces</li>
                  <li><i className="fa fa-check-circle"></i> Parking available in building complex</li>
                  <li><i className="fa fa-check-circle"></i> Wheelchair accessible with elevator access</li>
                  <li><i className="fa fa-check-circle"></i> On-site technical demonstration lab</li>
                </ul>
              </div>
              
              <div className="visitor-info">
                <h3><i className="fa fa-info-circle"></i> Visitor Information</h3>
                <div className="visitor-tips">
                  <div className="tip">
                    <i className="fa fa-car"></i>
                    <div>
                      <h4>Parking</h4>
                      <p>Free visitor parking in designated areas</p>
                    </div>
                  </div>
                  <div className="tip">
                    <i className="fa fa-subway"></i>
                    <div>
                      <h4>Public Transport</h4>
                      <p>Accessible via Metro bus routes 25, 65, 85</p>
                    </div>
                  </div>
                  <div className="tip">
                    <i className="fa fa-clock"></i>
                    <div>
                      <h4>Meeting Times</h4>
                      <p>Schedule meetings between 9 AM - 5 PM</p>
                    </div>
                  </div>
                  <div className="tip">
                    <i className="fa fa-bell"></i>
                    <div>
                      <h4>Check-in</h4>
                      <p>Register at reception upon arrival</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Global Reach Section */}
      <section className="global-reach-section">
        <div className="container">
          <div className="section-header">
            <h1 style={{ color: '#00e7ff' }}>Our Global Presence</h1>
            <p className="section-subtitle">
              Serving clients across multiple regions with remote and on-site capabilities
            </p>
          </div>
          
          <div className="global-grid">
            <div className="region-card">
              <div className="region-icon">
                <i className="fa fa-flag-usa"></i>
              </div>
              <h3>North America</h3>
              <p>United States, Canada, Mexico</p>
              <ul>
                <li>Primary clients in Texas, California, New York</li>
                <li>24/7 support for EST, CST, PST timezones</li>
                <li>On-site teams available in major cities</li>
              </ul>
            </div>
            
            <div className="region-card">
              <div className="region-icon">
                <i className="fa fa-globe-europe"></i>
              </div>
              <h3>Europe</h3>
              <p>UK, Germany, France, Netherlands</p>
              <ul>
                <li>Remote development teams</li>
                <li>Compliance expertise (GDPR, etc.)</li>
                <li>Localized support during business hours</li>
              </ul>
            </div>
            
            <div className="region-card">
              <div className="region-icon">
                <i className="fa fa-globe-asia"></i>
              </div>
              <h3>Asia Pacific</h3>
              <p>India, Singapore, Australia, Japan</p>
              <ul>
                <li>Development centers in India</li>
                <li>Cloud infrastructure management</li>
                <li>Follow-the-sun support model</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact CTA 123 */}
      <section className="quick-contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2 style={{ color: '#00e7ff' }}>Ready to Start Your Project?</h2>
            <p>
              Get in touch today for a free consultation. Our experts are ready to discuss 
              your technology challenges and propose innovative solutions.
            </p>
            
            <div className="quick-contact-options">
              
              <a href="mailto:contactus@vinfocloud.com" className="quick-contact-btn email-btn">
                <i className="fa fa-envelope"></i>
                <span>Email Us</span>
              </a>
            
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;